import "core-js/modules/es6.array.filter";
import { removeSingleFilterValue } from "../helpers";
/**
 * Remove filter from results
 *
 * Will trigger new search
 *
 * @param name String field name for filter to remove
 * @param value String (Optional) field value for filter to remove
 * @param type String (Optional) type of filter to remove
 */

export default function removeFilter(name, value, type) {
  var _console;

  if (this.debug) // eslint-disable-next-line no-console
    (_console = console).log.apply(_console, ["Search UI: Action", "removeFilter"].concat(Array.prototype.slice.call(arguments)));
  var filters = this.state.filters;
  var updatedFilters = filters;

  if (!value && type) {
    updatedFilters = filters.filter(function (filter) {
      return !(filter.field === name && filter.type === type);
    });
  } else if (value) {
    updatedFilters = removeSingleFilterValue(filters, name, value, type);
  } else {
    updatedFilters = filters.filter(function (filter) {
      return filter.field !== name;
    });
  }

  this._updateSearchResults({
    current: 1,
    filters: updatedFilters
  });
}